<script setup lang="ts">
import CategoriesMobileItem from "./CategoriesMobileItem.vue";
import type { ICategory } from "@magnit/unit-catalog/src/unit-catalog.types";
import { computed } from "vue";
import type { ICategoriesFunctions } from "../types";

const modelValue = defineModel<ICategory["key"]>({ default: "" });

const props = defineProps<{
  categoriesStore: ICategoriesFunctions;
}>();

const currentCategory = computed<ICategory | null>(() =>
  props.categoriesStore.getCategoryByKey(modelValue.value),
);

const parents = computed(() => {
  let parents = props.categoriesStore.getParentsByKey(modelValue.value);
  const type = props.categoriesStore.getTypeByKey(modelValue.value);

  const base = props.categoriesStore.getCategoryById(
    "",
    type === "promo" ? "goods" : "promo",
  );

  if (base) {
    parents = [base, ...parents];
  }

  if (currentCategory.value?.children.length) {
    parents.push(currentCategory.value);
  }

  return parents;
});
</script>

<template>
  <div class="filters-category-mobile">
    <template v-for="(category, index) in parents" :key="category.key">
      <CategoriesMobileItem
        v-model="modelValue"
        :show-icon="!index"
        :category="category"
        :class="`children-level-${index - 1}`"
      />
      <hr v-if="!index" />
      <template v-if="index === parents.length - 1">
        <CategoriesMobileItem
          v-for="children in category.children"
          :key="children.key"
          v-model="modelValue"
          :category="children"
          :class="`children-level-${index}`"
        />
      </template>
    </template>
  </div>
</template>

<style lang="postcss" scoped>
.filters-category-mobile {
  @for $i from 1 to 3 {
    .children-level-$(i) {
      padding-left: calc($i * 24px);
    }
  }
}
</style>
